import React from 'react';

export const RequestAccessRoute = React.lazy(() =>
  import(/* webpackChunkName: "access" */ '../../features/RequestAccess/Route'),
);

export const InviteRoute = React.lazy(() =>
  import(
    /* webpackChunkName: "get-access" */ '../../features/AccessControls/Invite/Route'
  ),
);

export const AddArtistRoute = React.lazy(() =>
  import(
    /* webpackChunkName: "add-artist" */ '../../features/AccessControls/AddArtistRoute'
  ),
);

export const SettingsRoute = React.lazy(() =>
  import(
    /* webpackChunkName: "settings" */ '../../features/UserSettings/Route'
  ),
);

export const ContentMismatchRoute = React.lazy(() =>
  import(
    /* webpackChunkName: "content-mismatch" */ '../../features/ArtistProfile/ContentMismatch/Route'
  ),
);

export const RootRoute = React.lazy(() =>
  import(/* webpackChunkName: "root" */ '../RootRoute'),
);
